import React from 'react';
import { IconInfoRegular } from '@croquiscom-pvt/zds';
import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { HelpDrawer } from '@common/overlay-manager';
import { Typography } from '@common/styles';
import { TouchAccessibilityWrapper } from '@domains/pdp-common';

import { MileageHelpText } from './MileageHelpText';

interface Prop {
  shopName: string;
  sellerSpecificUseMileageRate: number;
  defaultUseMileageRate: number;
  totalUseMileageRate: number;
}

export const MileageUsableInfo: React.FC<React.PropsWithChildren<Prop>> = ({
  shopName,
  sellerSpecificUseMileageRate,
  defaultUseMileageRate,
  totalUseMileageRate,
}) => {
  const [isHelpDrawerOpen, setIsHelpDrawerOpen] = React.useState(false);

  const handleInfoClick = () => {
    setIsHelpDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsHelpDrawerOpen(false);
  };

  return (
    <Container>
      <Title as='p' variant='Body_14_Medium' color='textTertiary'>
        사용 가능
      </Title>
      <Contents>
        <MileageGuide as='div' variant='Body_14_Medium' v3Color='gray950'>
          결제 시 <span>{totalUseMileageRate}%</span>까지 마일리지 사용 가능
          <MileageGuideInfoWrap as='div'>
            <TouchAccessibilityWrapper touchWidth={24} touchHeight={24} onClick={handleInfoClick}>
              <IconInfoRegular color='textTertiary' size={18} />
            </TouchAccessibilityWrapper>
          </MileageGuideInfoWrap>
        </MileageGuide>
        <AddText as='p' variant='Body_14_Regular' color='gray500'>
          <Pre>기본 {defaultUseMileageRate}% + </Pre>
          <Elipsis>{shopName} </Elipsis>
          <Color>{sellerSpecificUseMileageRate}% 추가</Color>
        </AddText>
      </Contents>
      <HelpDrawer open={isHelpDrawerOpen} title='' onClose={handleCloseDrawer}>
        <HelpDrawerInner>
          <MileageHelpText />
        </HelpDrawerInner>
      </HelpDrawer>
    </Container>
  );
};

const Container = styled.div`
  margin: 0 16px;
  padding: 16px 0;
  display: flex;
  align-items: flex-start;
`;

const HelpDrawerInner = styled.div`
  position: relative;
  top: -16px;
  margin-left: -4px;
  margin-right: -4px;
`;

const MileageGuide = styled(Text)`
  position: relative;
  width: fit-content;
`;

const MileageGuideInfoWrap = styled.div`
  position: absolute;
  top: 50%;
  right: -18px;
  transform: translateY(-50%);
`;

const Title = styled(Text)`
  min-width: 56px;
  margin-right: 8px;
`;

const Contents = styled.div`
  position: relative;
  top: -1px;
  width: calc(100% - 64px);
`;

const AddText = styled(Text)`
  display: flex;
  align-items: center;
  margin: 6px 0 0 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  white-space: pre;
`;
const Color = styled.span`
  color: #f5833d;
`;

const Pre = styled.span`
  white-space: pre;
`;

const Elipsis = styled.span`
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
`;
